import { BRANCH_API } from "shared/constants/api-endpoint";
import { apiClient } from "shared/plugins/http-service";
import { BranchModel } from "./branch.models";

export const getBranchList = () => {
  return apiClient.getHttp<BranchModel[]>(`${BRANCH_API}`, undefined, false);
};
